import { IMultipleSend } from "@/shared/model/global/dashboard/multiple-send";
import axios from "axios";
import { ProfileInfos } from "../model/profile-infos.model";
import { ISignUpForm } from "../model/sign-up-form";

const baseApiUrl = "api/platform";

export default class PlatformService {
  public updateAccountInfos(entity): Promise<ProfileInfos> {
    return new Promise<ProfileInfos>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}/update-account-infos`, entity)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public updateProfilePicture(entity): Promise<string> {
    return new Promise<string>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}/update-profile-picture`, entity)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public updateCompanyLogo(entity): Promise<string> {
    return new Promise<string>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}/company-logo`, entity)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  public sendFeedbackForm(entity): Promise<string> {
    return new Promise<string>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}/feedback-form`, entity)
        .then(function (res) {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }
}
